// jquery
$(document).ready(() => {
  const isRTL = $('#content-wrapper').attr('dir') === 'rtl';
  $('#oc-container .card__color-toggle').each((key, item) => {
    const $imageList = $(item).find('.color-toggle__img-list');
    const $dotsWrapper = $(item).find('.color-toggle__dots');
    const $text = $(item).find('.color-toggle__text');

    $imageList.on('init', (e) => {
      e.stopPropagation();
    });

    $imageList.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
      event.stopPropagation();
      const $el = slick.$slides.eq(nextSlide);
      window.handleClickTracking($el);
      const newText = $el.data('name');
      $text.text(newText);
    });

    // init slick
    $imageList.slick({
      arrows: false,
      swipe: false,
      fade: true,
      dots: true,
      rtl: isRTL,
      appendDots: $dotsWrapper,
      customPaging: (slick, index) => {
        const $el = slick.$slides.eq(index);
        const colorClass = $el.data('color');
        return `<div class="color-toggle__dots-item ${colorClass}" role="button" />`;
      },
    });
  });
});
